<template>
	<div class="mb-4">
		<CancellationsList></CancellationsList>
	</div>
</template>

<script>
import CancellationsList from '@/components/Widgets/Cancellations/CancellationsList.vue';
export default {
  name: 'Cancellations',
  components: {
    CancellationsList,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>